import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";


@Component({
  selector: 'ssab-cx-clear-cart',
  templateUrl: './delete-claim-document.component.html'
})
export class DeleteClaimDocumentComponent {

  constructor(
    public dialogRef: MatDialogRef<DeleteClaimDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {batchItemNote: string, identifier: string}
  ) {
  }

  closeDialog(deleteDocument:boolean): void {
    this.dialogRef.close(deleteDocument);
  }

}
